import { render, staticRenderFns } from "./profileMatches.vue?vue&type=template&id=c7f95e56&scoped=true"
import script from "./profileMatches.vue?vue&type=script&lang=js"
export * from "./profileMatches.vue?vue&type=script&lang=js"
import style0 from "./profileMatches.vue?vue&type=style&index=0&id=c7f95e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f95e56",
  null
  
)

export default component.exports